module.exports = __webpack_public_path__ + "images/109df786f450549a603a82f22ecf5f20.jpg";